export default __webpack_public_path__ + "static/page_pp_m-d5738693362458f2de275cd64a2fd104.png";